/* Virute Studio — página de coleção: filtros, ordenação, carregar mais, pontos de cor e adição rápida.
   Os produtos da coleção vêm todos no HTML, por isso os filtros não dependem de nenhuma app. */
(function () {
  var root = document.querySelector('[data-vs-collection]');
  if (!root || root.dataset.ready || !root.querySelector('[data-vs-card]')) return;
  root.dataset.ready = '1';
  var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfg = root.dataset;
  var STEP = parseInt(cfg.step, 10) || 12;
  var TILE_POS = parseInt(cfg.tilePos, 10) || 5;
  var grid = root.querySelector('[data-grid]');
  var tile = root.querySelector('[data-tile]');
  var facets = root.querySelector('[data-facets]');
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '6XL'];
  var COLOR_ALIAS = { camelo: 'Camel', 'bordô': 'Bordeaux' };
  var SIZE_ALIAS = { XXL: '2XL', XXXL: '3XL' };

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function normColor(c) { return COLOR_ALIAS[String(c).toLowerCase()] || c; }
  function normSize(s) { return SIZE_ALIAS[s] || s; }
  function lines(txt) {
    return String(txt || '').split(/\r?\n/).map(function (l) {
      var p = l.split(':');
      if (p.length < 2) return null;
      return { label: p[0].trim(), keys: p.slice(1).join(':').split(',').map(function (k) { return k.trim().toLowerCase(); }).filter(Boolean) };
    }).filter(Boolean);
  }

  var items = [].slice.call(root.querySelectorAll('[data-vs-card]')).map(function (el, i) {
    var d = JSON.parse(el.getAttribute('data-vs'));
    d.el = el;
    d.i = i;
    d.cur = el.getAttribute('data-c') || '';
    d.tagsLow = d.tags.map(function (t) { return t.toLowerCase(); });
    d.text = (d.title + ' ' + d.tags.join(' ')).toLowerCase();
    return d;
  });

  var state = { pill: '', sizes: [], colors: [], mats: [], sale: false, stock: false, min: null, max: null, sort: '', shown: STEP };

  /* ---------- Seleção de cor no cartão ---------- */
  function refreshSizes(d) {
    d.el.querySelectorAll('[data-qa-size]').forEach(function (b) {
      var s = b.getAttribute('data-qa-size');
      b.disabled = !d.v.some(function (v) { return v[2] === s && v[3] && (!d.cur || v[1] === d.cur); });
    });
  }
  function setColor(d, name) {
    var dot = [].filter.call(d.el.querySelectorAll('[data-vs-cdot]'), function (x) { return x.getAttribute('data-c') === name; })[0];
    if (!dot) return;
    d.cur = name;
    var src = dot.getAttribute('data-img');
    var url = dot.getAttribute('data-url');
    var img = d.el.querySelector('.vs-card__img1');
    if (img && src && img.getAttribute('src') !== src) {
      img.src = src;
      img.removeAttribute('srcset');
      var hover = d.el.querySelector('.vs-card__img2');
      if (hover) hover.remove();
    }
    if (url) d.el.querySelectorAll('.vs-card__link, .vs-card__title').forEach(function (a) { a.href = url; });
    d.el.querySelectorAll('[data-vs-cdot]').forEach(function (x) { x.setAttribute('aria-pressed', x === dot ? 'true' : 'false'); });
    refreshSizes(d);
  }

  /* ---------- Construção dos filtros ---------- */
  var mats = lines(cfg.materials).filter(function (m) {
    return items.some(function (d) { return m.keys.some(function (k) { return d.text.indexOf(k) > -1; }); });
  });
  var pills = [];
  var types = [];
  items.forEach(function (d) { if (d.type && types.indexOf(d.type) < 0) types.push(d.type); });
  if (types.length > 1) {
    pills = types.map(function (t) { return { label: t, test: function (d) { return d.type === t; } }; });
  } else {
    pills = lines(cfg.pills).map(function (p) {
      return { label: p.label, test: function (d) { return d.tagsLow.some(function (t) { return p.keys.indexOf(t) > -1; }); } };
    }).filter(function (p) {
      var n = items.filter(p.test).length;
      return n > 0 && n < items.length;
    });
  }

  var sizes = [];
  var colors = [];
  var colorCount = {};
  var swatches = {};
  items.forEach(function (d) {
    var own = {};
    d.v.forEach(function (v) {
      if (v[2] && sizes.indexOf(normSize(v[2])) < 0) sizes.push(normSize(v[2]));
      if (v[1]) {
        var c = normColor(v[1]);
        if (colors.indexOf(c) < 0) colors.push(c);
        own[c] = 1;
      }
    });
    Object.keys(own).forEach(function (c) { colorCount[c] = (colorCount[c] || 0) + 1; });
    d.el.querySelectorAll('[data-vs-cdot]').forEach(function (dot) {
      var key = normColor(dot.getAttribute('data-c'));
      if (!swatches[key]) swatches[key] = dot.querySelector('.swatch').outerHTML;
    });
  });
  sizes.sort(function (a, b) {
    var ai = SIZE_ORDER.indexOf(a), bi = SIZE_ORDER.indexOf(b);
    var an = parseFloat(a), bn = parseFloat(b);
    if (ai > -1 && bi > -1) return ai - bi;
    if (ai > -1) return -1;
    if (bi > -1) return 1;
    return an - bn;
  });
  /* As cores mais frequentes primeiro: são as que ficam visíveis antes de "Ver mais cores". */
  colors.sort(function (a, b) { return (colorCount[b] - colorCount[a]) || a.localeCompare(b, 'pt'); });
  var prices = items.map(function (d) { return d.price / 100; });
  var priceMin = prices.length ? Math.floor(Math.min.apply(null, prices)) : 0;
  var priceMax = prices.length ? Math.ceil(Math.max.apply(null, prices)) : 0;

  function group(title, inner) { return '<div class="vs-fgroup"><p class="vs-fgroup__t">' + esc(title) + '</p>' + inner + '</div>'; }
  var html = '';
  if (sizes.length > 1) {
    html += group(cfg.lSize, '<div class="vs-fsizes">' + sizes.map(function (s) {
      return '<button type="button" class="vs-fsize" data-f="sizes" data-v="' + esc(s) + '" aria-pressed="false">' + esc(s) + '</button>';
    }).join('') + '</div>');
  }
  if (colors.length > 1) {
    html += group(cfg.lColor, '<div class="vs-fcolors" data-fcolors>' + colors.map(function (c) {
      return '<button type="button" class="vs-fcolor" data-f="colors" data-v="' + esc(c) + '" aria-pressed="false">' + (swatches[c] || '') + '<span>' + esc(c) + '</span></button>';
    }).join('') + '</div>' + (colors.length > 8 ? '<button type="button" class="vs-fmore" data-fmore>' + esc(cfg.lMore) + '</button>' : ''));
  }
  if (priceMax > priceMin) {
    var rng = 'min="' + priceMin + '" max="' + priceMax + '" step="1"';
    html += group(cfg.lPrice, '<div class="vs-frange"><span class="vs-frange__track"></span><span class="vs-frange__fill" data-rfill></span>' +
      '<input type="range" ' + rng + ' value="' + priceMin + '" data-rmin aria-label="' + esc(cfg.lPrice) + ' mínimo">' +
      '<input type="range" ' + rng + ' value="' + priceMax + '" data-rmax aria-label="' + esc(cfg.lPrice) + ' máximo"></div>' +
      '<div class="vs-frange__vals"><span data-rminv></span><span data-rmaxv></span></div>');
  }
  if (mats.length > 1) {
    html += group(cfg.lMat, mats.map(function (m) {
      return '<label class="vs-fcheck"><input type="checkbox" data-fmat value="' + esc(m.label) + '"><span>' + esc(m.label) + '</span></label>';
    }).join(''));
  }
  html += '<div class="vs-fgroup">' +
    (items.some(function (d) { return d.sale; }) && !items.every(function (d) { return d.sale; }) ? '<label class="vs-fcheck"><input type="checkbox" data-fsale><span>' + esc(cfg.lSale) + '</span></label>' : '') +
    '<label class="vs-fcheck"><input type="checkbox" data-fstock><span>' + esc(cfg.lStock) + '</span></label></div>';
  facets.innerHTML = html;

  var pillBox = root.querySelector('[data-pills]');
  if (pills.length) {
    pillBox.innerHTML = '<button type="button" class="vs-pill" data-pill="" aria-pressed="true">' + esc(cfg.lAll) + '</button>' + pills.map(function (p) {
      return '<button type="button" class="vs-pill" data-pill="' + esc(p.label) + '" aria-pressed="false">' + esc(p.label) + '</button>';
    }).join('');
  }

  /* ---------- Estado na URL (para o botão Voltar) ---------- */
  function readUrl() {
    var q = new URLSearchParams(location.search);
    state.pill = q.get('tipo') || '';
    state.sizes = q.getAll('tamanho').filter(function (s) { return sizes.indexOf(s) > -1; });
    state.colors = q.getAll('cor').filter(function (c) { return colors.indexOf(c) > -1; });
    state.mats = q.getAll('tecido').filter(function (m) { return mats.some(function (x) { return x.label === m; }); });
    state.sale = q.get('promo') === '1';
    state.stock = q.get('stock') === '1';
    state.sort = q.get('ordenar') || '';
    var mi = parseInt(q.get('min'), 10), ma = parseInt(q.get('max'), 10);
    state.min = isNaN(mi) ? null : mi;
    state.max = isNaN(ma) ? null : ma;
  }
  function writeUrl() {
    var q = new URLSearchParams(location.search);
    ['tipo', 'tamanho', 'cor', 'tecido', 'promo', 'stock', 'ordenar', 'min', 'max'].forEach(function (k) { q.delete(k); });
    if (state.pill) q.set('tipo', state.pill);
    state.sizes.forEach(function (s) { q.append('tamanho', s); });
    state.colors.forEach(function (c) { q.append('cor', c); });
    state.mats.forEach(function (m) { q.append('tecido', m); });
    if (state.sale) q.set('promo', '1');
    if (state.stock) q.set('stock', '1');
    if (state.sort) q.set('ordenar', state.sort);
    if (state.min !== null) q.set('min', state.min);
    if (state.max !== null) q.set('max', state.max);
    var s = q.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash);
  }

  /* ---------- Filtrar ---------- */
  function matches(d) {
    if (state.pill) {
      var p = pills.filter(function (x) { return x.label === state.pill; })[0];
      if (p && !p.test(d)) return false;
    }
    if (state.sale && !d.sale) return false;
    if (state.stock && !d.avail) return false;
    if (state.min !== null && d.price / 100 < state.min) return false;
    if (state.max !== null && d.price / 100 > state.max) return false;
    if (state.mats.length && !state.mats.some(function (lbl) {
      var m = mats.filter(function (x) { return x.label === lbl; })[0];
      return m && m.keys.some(function (k) { return d.text.indexOf(k) > -1; });
    })) return false;
    if (state.sizes.length || state.colors.length) {
      return d.v.some(function (v) {
        if (!v[3]) return false;
        if (state.sizes.length && state.sizes.indexOf(normSize(v[2])) < 0) return false;
        if (state.colors.length && state.colors.indexOf(normColor(v[1])) < 0) return false;
        return true;
      });
    }
    return true;
  }
  function sorted(list) {
    var s = state.sort;
    return list.slice().sort(function (a, b) {
      if (s === 'preco-asc') return a.price - b.price || a.i - b.i;
      if (s === 'preco-desc') return b.price - a.price || a.i - b.i;
      if (s === 'recentes') return b.pub - a.pub || a.i - b.i;
      if (s === 'az') return a.title.localeCompare(b.title, 'pt');
      return a.i - b.i;
    });
  }
  function activeCount() {
    return state.sizes.length + state.colors.length + state.mats.length + (state.sale ? 1 : 0) + (state.stock ? 1 : 0) + (state.min !== null || state.max !== null ? 1 : 0);
  }
  function money(n) { return n + ' €'; }

  function syncControls() {
    root.querySelectorAll('[data-f]').forEach(function (b) {
      b.setAttribute('aria-pressed', state[b.getAttribute('data-f')].indexOf(b.getAttribute('data-v')) > -1 ? 'true' : 'false');
    });
    root.querySelectorAll('[data-pill]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-pill') === state.pill ? 'true' : 'false'); });
    root.querySelectorAll('[data-fmat]').forEach(function (c) { c.checked = state.mats.indexOf(c.value) > -1; });
    var fs = root.querySelector('[data-fsale]'); if (fs) fs.checked = state.sale;
    var fk = root.querySelector('[data-fstock]'); if (fk) fk.checked = state.stock;
    var sel = root.querySelector('[data-sort]'); if (sel) sel.value = state.sort;
    var rmin = root.querySelector('[data-rmin]');
    if (rmin) {
      var rmax = root.querySelector('[data-rmax]');
      var lo = state.min === null ? priceMin : state.min;
      var hi = state.max === null ? priceMax : state.max;
      rmin.value = lo; rmax.value = hi;
      var span = (priceMax - priceMin) || 1;
      var fill = root.querySelector('[data-rfill]');
      fill.style.left = ((lo - priceMin) / span * 100) + '%';
      fill.style.right = ((priceMax - hi) / span * 100) + '%';
      root.querySelector('[data-rminv]').textContent = money(lo);
      root.querySelector('[data-rmaxv]').textContent = money(hi);
    }
  }

  function chips() {
    var box = root.querySelector('[data-chips]');
    var out = '';
    function chip(kind, val, label) { out += '<button type="button" class="vs-chip" data-chip="' + kind + '" data-v="' + esc(val) + '">' + esc(label) + ' <span aria-hidden="true">×</span></button>'; }
    state.sizes.forEach(function (s) { chip('sizes', s, cfg.lSize + ' ' + s); });
    state.colors.forEach(function (c) { chip('colors', c, c); });
    state.mats.forEach(function (m) { chip('mats', m, m); });
    if (state.min !== null || state.max !== null) chip('price', '', money(state.min === null ? priceMin : state.min) + ' – ' + money(state.max === null ? priceMax : state.max));
    if (state.sale) chip('sale', '', cfg.lSale);
    if (state.stock) chip('stock', '', cfg.lStock);
    if (out) out += '<button type="button" class="vs-chip vs-chip--clear" data-clear>' + esc(cfg.lClear) + '</button>';
    box.innerHTML = out;
  }

  function labelToggle() {
    var n = activeCount();
    var suffix = n ? ' (' + n + ')' : '';
    var mobile = window.matchMedia('(max-width:749px)').matches;
    var txt = mobile ? cfg.lFilters : (root.classList.contains('is-nofilters') ? cfg.lShow : cfg.lHide);
    root.querySelector('[data-toggle-label]').textContent = txt + suffix;
  }

  function update(keepShown) {
    if (!keepShown) state.shown = STEP;
    var vis = sorted(items.filter(matches));
    sorted(items).forEach(function (d) { d.el.hidden = true; grid.appendChild(d.el); });
    vis.forEach(function (d, n) { d.el.hidden = n >= state.shown; });
    if (state.colors.length) {
      vis.forEach(function (d) {
        var hit = d.v.filter(function (v) { return v[1] && state.colors.indexOf(normColor(v[1])) > -1; })[0];
        if (hit && normColor(d.cur) !== normColor(hit[1])) setColor(d, hit[1]);
      });
    }
    if (tile) {
      var clean = !activeCount() && !state.pill && !state.sort;
      var showTile = clean && vis.length >= TILE_POS;
      tile.hidden = !showTile;
      if (showTile) grid.insertBefore(tile, vis[TILE_POS - 1].el);
    }
    var total = vis.length;
    var seen = Math.min(state.shown, total);
    root.querySelector('[data-count]').textContent = total + ' ' + (total === 1 ? cfg.lProduct : cfg.lProducts);
    var more = root.querySelector('[data-more]');
    more.hidden = total <= STEP;
    root.querySelector('[data-seen]').textContent = cfg.lSeen.replace('[x]', seen).replace('[y]', total);
    root.querySelector('[data-prog]').style.width = (total ? seen / total * 100 : 0) + '%';
    root.querySelector('[data-load]').hidden = seen >= total;
    root.querySelector('[data-empty]').hidden = total > 0;
    var apply = root.querySelector('[data-apply]');
    if (apply) apply.textContent = cfg.lApply.replace('[n]', total);
    syncControls();
    chips();
    labelToggle();
    writeUrl();
  }

  function clearAll() {
    state.sizes = []; state.colors = []; state.mats = []; state.sale = false; state.stock = false; state.min = null; state.max = null;
    update();
  }

  /* ---------- Eventos ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var f = t.closest('[data-f]');
    if (f) {
      var key = f.getAttribute('data-f'), val = f.getAttribute('data-v');
      var pos = state[key].indexOf(val);
      if (pos > -1) state[key].splice(pos, 1); else state[key].push(val);
      update();
      return;
    }
    var pill = t.closest('[data-pill]');
    if (pill) { state.pill = pill.getAttribute('data-pill'); update(); return; }
    if (t.closest('[data-fmore]')) {
      var box = root.querySelector('[data-fcolors]');
      box.classList.toggle('is-all');
      t.closest('[data-fmore]').textContent = box.classList.contains('is-all') ? cfg.lLess : cfg.lMore;
      return;
    }
    var chip = t.closest('[data-chip]');
    if (chip) {
      var k = chip.getAttribute('data-chip'), v = chip.getAttribute('data-v');
      if (k === 'price') { state.min = null; state.max = null; }
      else if (k === 'sale') state.sale = false;
      else if (k === 'stock') state.stock = false;
      else state[k] = state[k].filter(function (x) { return x !== v; });
      update();
      return;
    }
    if (t.closest('[data-clear]')) { clearAll(); return; }
    if (t.closest('[data-load]')) { state.shown += STEP; update(true); return; }
    if (t.closest('[data-toggle]')) {
      if (window.matchMedia('(max-width:749px)').matches) root.classList.add('is-open');
      else root.classList.toggle('is-nofilters');
      labelToggle();
      return;
    }
    if (t.closest('[data-close]') || t.closest('[data-apply]')) { root.classList.remove('is-open'); return; }

    var dot = t.closest('[data-vs-cdot]');
    if (dot) {
      var d = byEl(dot);
      if (d) setColor(d, dot.getAttribute('data-c'));
      return;
    }
    var open = t.closest('[data-qa-open]');
    if (open) {
      var card = open.closest('[data-vs-card]');
      var isOpen = card.classList.toggle('is-qa');
      open.textContent = isOpen ? '×' : '+';
      open.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }
    var add = t.closest('[data-qa-size], [data-qa-one]');
    if (add) { quickAdd(add); }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-fsale]')) { state.sale = t.checked; update(); }
    else if (t.matches('[data-fstock]')) { state.stock = t.checked; update(); }
    else if (t.matches('[data-fmat]')) {
      state.mats = state.mats.filter(function (m) { return m !== t.value; });
      if (t.checked) state.mats.push(t.value);
      update();
    }
    else if (t.matches('[data-sort]')) { state.sort = t.value; update(); }
    else if (t.matches('[data-rmin],[data-rmax]')) { update(); }
  });
  root.addEventListener('input', function (e) {
    var t = e.target;
    if (!t.matches('[data-rmin],[data-rmax]')) return;
    var lo = +root.querySelector('[data-rmin]').value;
    var hi = +root.querySelector('[data-rmax]').value;
    if (lo > hi) { if (t.matches('[data-rmin]')) lo = hi; else hi = lo; }
    state.min = lo === priceMin ? null : lo;
    state.max = hi === priceMax ? null : hi;
    syncControls();
  });
  window.addEventListener('resize', labelToggle);

  function byEl(node) {
    var el = node.closest('[data-vs-card]');
    return items.filter(function (d) { return d.el === el; })[0];
  }

  /* ---------- Adição rápida ---------- */
  function quickAdd(btn) {
    var d = byEl(btn);
    if (!d) return;
    var size = btn.getAttribute('data-qa-size');
    var v = d.v.filter(function (x) {
      return x[3] && (!size || x[2] === size) && (!d.cur || x[1] === d.cur);
    })[0];
    var err = d.el.querySelector('.vs-qa__err');
    if (err) err.hidden = true;
    if (!v) return;
    var buttons = d.el.querySelectorAll('[data-qa-size], [data-qa-one]');
    buttons.forEach(function (b) { b.disabled = true; });
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v[0], quantity: 1 }], sections: 'cart-drawer-section' })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || cfg.lError);
        var html = res.j.sections && res.j.sections['cart-drawer-section'];
        var drawer = document.getElementById('cart-drawer');
        var cur = drawer && drawer.querySelector('.cart-drawer__inner');
        var fresh = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-drawer__inner') : null;
        if (!cur || !fresh || typeof drawer.open !== 'function') { window.location.href = rootUrl + 'cart'; return; }
        cur.replaceWith(fresh);
        drawer.open();
        d.el.classList.remove('is-qa');
        var o = d.el.querySelector('[data-qa-open]');
        if (o) { o.textContent = '+'; o.setAttribute('aria-expanded', 'false'); }
        return fetch(rootUrl + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('.cart-bubble__text-count, [data-cart-count], .header-actions__cart-count').forEach(function (el) { el.textContent = c.item_count; });
        });
      })
      .catch(function (ex) {
        if (err) { err.textContent = ex.message || cfg.lError; err.hidden = false; }
      })
      .then(function () {
        buttons.forEach(function (b) { b.disabled = false; });
        refreshSizes(d);
      });
  }

  /* ---------- Arranque ---------- */
  items.forEach(refreshSizes);
  readUrl();
  update();
})();
